module.exports = __webpack_public_path__ + "img/T7A6707.fed426fa.jpg";